// extracted by mini-css-extract-plugin
export var backInStockMessage = "styles-mod--back-in-stock-message--d154c";
export var backInStockSnippet = "styles-mod--back-in-stock-snippet--2d481";
export var form = "styles-mod--form--8390f";
export var iconText = "styles-mod--icon-text--903fd";
export var imgBox = "styles-mod--img-box--9d667";
export var submitCta = "styles-mod--submit-cta--9fb39";
export var successfullyMessage = "styles-mod--successfully-message--a673b";